<div class="portal-page">

  <div class="portal-shell">

    <!-- HERO -->
    <section class="portal-hero">

      <div class="portal-hero-content">

        <div>
          <span class="portal-eyebrow">
            HOLOWICKI ENTERPRISES
          </span>

          <h1>
            {{ portalType }} Portal
          </h1>

          @if (portalType === 'Crew') {
            <p>
              Quick access to crew resources, forms,
              tools and important links.
            </p>
          } @else {
            <p>
              Management tools, forms, operational
              resources and crew resources in one place.
            </p>
          }
        </div>

        <div class="portal-role">
          <span class="role-dot"></span>
          {{ portalType }}
        </div>

      </div>

    </section>


    <!-- CONTENT -->
    <main class="portal-content">

      <div class="content-heading">

        <span class="section-eyebrow">
          RESOURCES
        </span>

        <h2>
          {{ portalType === 'Crew'
            ? 'Everything you need'
            : 'Manager workspace'
          }}
        </h2>

        <p>
          Select a resource below to continue.
        </p>

      </div>


      @if (loading) {

        <div class="portal-state">
          Loading resources...
        </div>

      } @else if (error) {

        <div class="portal-state error">
          Unable to load portal resources.
        </div>

      } @else if (categories.length === 0) {

        <div class="portal-state">
          No resources are currently available.
        </div>

      } @else {

        <div class="category-list">

          @for (
            category of categories;
            track category.name
          ) {

            <section class="resource-section">

              <div class="resource-section-header">

                <div>
                  <span class="category-label">
                    RESOURCE GROUP
                  </span>

                  <h3>
                    {{ category.name }}
                  </h3>
                </div>

                <span class="resource-count">
                  {{ category.items.length }}
                  {{ category.items.length === 1
                    ? 'item'
                    : 'items'
                  }}
                </span>

              </div>


              <div class="resource-grid">

                @for (
                  item of category.items;
                  track item.id
                ) {

                  <button
                    type="button"
                    class="resource-card"
                    [class.placeholder]="isPlaceholder(item)"
                    [class.document]="isDocument(item)"
                    [disabled]="isPlaceholder(item)"
                    (click)="openItem(item)"
                  >

                    <div class="resource-card-main">

                      <div class="resource-icon">

                        @if (isDocument(item)) {
                          <span>▤</span>
                        } @else if (item.url) {
                          <span>↗</span>
                        } @else {
                          <span>•</span>
                        }

                      </div>


                      <div class="resource-card-content">

                        <h4>
                          {{ item.name }}
                        </h4>

                        @if (isDocument(item)) {

                          <span class="resource-type">
                            View document
                          </span>

                        } @else if (item.url) {

                          <span class="resource-type">
                            Open resource
                          </span>

                        } @else {

                          <span class="resource-type coming-soon">
                            Coming soon
                          </span>

                        }

                      </div>

                    </div>


                    @if (!isPlaceholder(item)) {

                      <span class="resource-arrow">
                        ›
                      </span>

                    }

                  </button>

                }

              </div>

            </section>

          }

        </div>

      }

    </main>

  </div>

</div>